// extracted by mini-css-extract-plugin
module.exports = {"health-message-edit":"health-message-edit-d538344d7ea97a1554cec2a5a376fbf6","button-div":"button-div-11eae2a4d081c7c62f409e43cd5eaa42"};